<div #menuContainer (clickOutside)="onClickedOutside()"
     [drMenuPosition]="option"
     [position]="position"
     class="menu-wrapper"
>
    <nb-card class="ct-menu-card">
        <nb-card-body>
            <div #listMenu *ngIf="!!list.length" class="ct-menu-container">
                <div (click)="action(act)"
                     *ngFor="let act of list"
                     [nbTooltipPlacement]="'left'"
                     [nbTooltipTrigger]="tooltipTrigger(act)"
                     [nbTooltip]="act.toolTip"
                     [ngClass]="{'ct-disabled': disabled(act)}"
                     [title]="act.title"
                     class="ct-menu-item">

                    <nb-icon *ngIf="act.icon" [icon]="act.icon" class="fa"></nb-icon>
                    <span class="ct-menu-item-text">{{act.title}}</span>
                </div>
            </div>
        </nb-card-body>
    </nb-card>
</div>
